module.exports = __webpack_public_path__ + "img/thumbnail-banner-2.06cfc221.webp";